// Home SmugMug carousel bg-scene sizer.
//
// The scene atom (atoms/_stickyBgScene.twig) is rendered as a preceding
// sibling of the `#image-carousel.block-anchor` wrapper. It has 0 net
// flow contribution, so the pattern's natural Y equals the top of that
// wrapper.
//
// Goal: pattern starts where it naturally sits (top of the carousel
// block) and ends at the vertical centre of the carousel image — so the
// pattern → video transition lands midway behind the photo. Computed
// from real rendered dimensions on every resize so it works at any
// breakpoint without hard-coded values.

const SELECTOR_BLOCK = '#image-carousel'
const SELECTOR_PATTERN = '[data-scene-pattern]'
const SELECTOR_VIDEO = '[data-scene-video]'
const SELECTOR_FRAME = '.ic-frame'
const VIDEO_HEIGHT_VH = 100

function findSceneFor(block) {
    let pattern = null
    let video = null
    let prev = block.previousElementSibling
    while (prev) {
        if (!video && prev.matches(SELECTOR_VIDEO)) video = prev
        else if (prev.matches(SELECTOR_PATTERN)) { pattern = prev; break }
        prev = prev.previousElementSibling
    }
    return { pattern, video }
}

function pickFrame(block) {
    return block.querySelector('.swiper-slide-active ' + SELECTOR_FRAME)
        || block.querySelector(SELECTOR_FRAME)
}

function position(block) {
    const { pattern, video } = findSceneFor(block)
    if (!pattern || !video) return

    const frame = pickFrame(block)
    if (!frame) return

    const blockTopY = block.getBoundingClientRect().top + window.scrollY
    const frameRect = frame.getBoundingClientRect()
    const frameCenterY = frameRect.top + frameRect.height / 2 + window.scrollY

    const h = Math.round(Math.max(0, frameCenterY - blockTopY))
    if (h <= 0) return

    pattern.style.height = `${h}px`
    pattern.style.marginTop = '0px'
    pattern.style.marginBottom = `${-h}px`
    video.style.marginTop = `${h}px`
    video.style.marginBottom = `calc(-${VIDEO_HEIGHT_VH}vh - ${h}px)`
}

const homeSmugmugBgScene = {
    init() {
        const block = document.querySelector(SELECTOR_BLOCK)
        if (!block) return

        const run = () => position(block)
        run()
        window.requestAnimationFrame(run)

        let resizeTimer
        window.addEventListener('resize', () => {
            clearTimeout(resizeTimer)
            resizeTimer = setTimeout(run, 150)
        })

        // Recompute once the active slide's image has loaded so we use
        // its real rendered height, not the placeholder 0.
        const img = block.querySelector('img')
        if (img && !img.complete) {
            img.addEventListener('load', run, { once: true })
        }
    },
}

export default homeSmugmugBgScene
